import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { LoginProviderService } from './service/login-provider.service';
import { Observable } from 'rxjs/internal/Observable';
import { CidaasService } from './service/cidaas.service';
import { map } from 'rxjs/internal/operators/map';
import { of } from 'rxjs/internal/observable/of';

@Injectable({
  providedIn: 'root',
})
export class ProviderHintGuard  {
  constructor(private loginProviderService: LoginProviderService, private cidaasService: CidaasService) { }

  // Handling of direct login provider redirect
  canActivate(
    route: ActivatedRouteSnapshot,
  ): Observable<boolean> {
    // Use case: Cidaas login should not get used, but instead we want to directly redirect to the login provider given in the request.
    let social_url = this.loginProviderService.handleLoginProviderHint(route.queryParams);
    if (social_url) {
      window.location.href = social_url;
      return of(false)
    }
    // If error or error description is present dont' auto-redirect
    if (!route.queryParams?.requestId ||
      route.queryParams.error ||
      route.queryParams.error_description) {
      return of(true);
    }
    // Handle auto-Redirect if only one login provider is set & allowed_login_methods is empty
    return this.cidaasService.getClientInfo$(route.queryParams.requestId).pipe(map(clientInfo => {
      let providerRedirectURI = this.loginProviderService.getProviderRedirectURI(clientInfo, route.queryParams.requestId)
      if (providerRedirectURI) {
        window.location.href = providerRedirectURI;
        return false;
      }
      return true
    }))
  }
}


